export default {
  // Page title
  'orders.title': 'Order Management',

  // Table columns
  'orders.table.orderId': 'Order ID',
  'orders.table.shopifyNumber': 'Shopify Number',
  'orders.table.shopifyId': 'Shopify ID',
  'orders.table.dearId': 'DEAR ID',
  'orders.table.channel': 'Channel',
  'orders.table.email': 'Email',
  'orders.table.dearStatus': 'DEAR Status',
  'orders.table.fulfillmentStatus': 'Fulfillment Status',
  'orders.table.createdAt': 'Created At',
  'orders.table.actions': 'Actions',

  // Status labels
  'orders.status.success': 'Success',
  'orders.status.failed': 'Failed',
  'orders.status.overall': 'Overall',
  'orders.status.sales': 'Sales',
  'orders.status.order': 'Order',
  'orders.status.invoice': 'Invoice',
  'orders.status.payment': 'Payment',
  'orders.status.fulfillment': 'Fulfillment',
  'orders.status.pick': 'Pick',
  'orders.status.pack': 'Pack',
  'orders.status.ship': 'Ship',

  // Status tooltips
  'orders.tooltip.dearOverall': 'DEAR Overall Success',
  'orders.tooltip.dearSales': 'DEAR Sales Success',
  'orders.tooltip.dearOrder': 'DEAR Order Success',
  'orders.tooltip.dearInvoice': 'DEAR Invoice Success',
  'orders.tooltip.dearPayment': 'DEAR Payment Success',
  'orders.tooltip.dearFulfillment': 'DEAR Fulfillment Success',
  'orders.tooltip.dearPick': 'DEAR Pick Success',
  'orders.tooltip.dearPack': 'DEAR Pack Success',
  'orders.tooltip.dearShip': 'DEAR Ship Success',
  'orders.tooltip.copyOrderNumber': 'Copy Order Number',

  // Actions
  'orders.actions.pushToDear': 'Push to DEAR',
  'orders.actions.fulfill': 'Fulfill Order',

  // Filters
  'orders.filter.shopifyId': 'Search Shopify ID',
  'orders.filter.email': 'Search Email',
  'orders.filter.channel': 'Select Channel',
  'orders.filter.startDate': 'Start Date',
  'orders.filter.endDate': 'End Date',
  'orders.filter.reset': 'Reset',

  // Channels
  'orders.channel.pointOfSale': 'Point of Sale',
  'orders.channel.onlineStore': 'Online Store',
  'orders.channel.facebook': 'Facebook',
  'orders.channel.instagram': 'Instagram',

  // Pagination
  'orders.pagination.total': '{start}-{end} of {total} items',

  // Messages
  'orders.message.getListFailed': 'Failed to get order list',
  'orders.message.pushSuccess': 'Order pushed successfully',
  'orders.message.pushFailed': 'Push failed',
  'orders.message.fulfillSuccess': 'Order fulfilled successfully',
  'orders.message.fulfillFailed': 'Failed to fulfill order',
  'orders.message.copySuccess': 'Order number copied: {number}',
  'orders.message.copyFailed': 'Copy failed',
};